module.exports = __webpack_public_path__ + "static/media/icon-basketball.25a3a3fb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-basketball.svg
// module id = ./src/assets/images/icon-basketball.svg
// module chunks = 6